export default __webpack_public_path__ + "static/journal-article-mobile-760a1bc7df5341d326a3d74fc2e16ca1.png";